var _path, _path2, _path3, _path4, _path5, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErroImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 118,
    viewBox: "0 0 83 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6345 52.6345C33.9065 53.3625 33.5 54.574 33.5 56.5833V61.5833C33.5 63.4362 33.8488 64.609 34.4683 65.3537C34.7331 65.6721 34.6897 66.145 34.3713 66.4099C34.0529 66.6748 33.58 66.6314 33.3151 66.313C32.3679 65.1743 32 63.5804 32 61.5833V56.5833C32 54.426 32.4269 52.7208 33.5738 51.5738C34.7208 50.4269 36.426 50 38.5833 50H43.5833C45.474 50 47.012 50.324 48.1367 51.1776C48.4667 51.428 48.5312 51.8985 48.2808 52.2284C48.0304 52.5584 47.5599 52.6228 47.2299 52.3724C46.488 51.8094 45.3427 51.5 43.5833 51.5H38.5833C36.574 51.5 35.3625 51.9065 34.6345 52.6345Z",
    fill: "#F94F44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3449 54.9931C49.7583 54.9673 50.1144 55.2815 50.1402 55.6949C50.158 55.9787 50.1667 56.2777 50.1667 56.5833V61.5833C50.1667 63.7406 49.7398 65.4459 48.5928 66.5928C47.4459 67.7398 45.7407 68.1667 43.5834 68.1667H38.5834C37.9418 68.1667 37.3326 68.1322 36.7639 68.0404C36.355 67.9745 36.077 67.5895 36.1429 67.1806C36.2089 66.7716 36.5938 66.4936 37.0028 66.5596C37.4674 66.6345 37.9916 66.6667 38.5834 66.6667H43.5834C45.5927 66.6667 46.8042 66.2602 47.5322 65.5322C48.2602 64.8041 48.6667 63.5927 48.6667 61.5833V56.5833C48.6667 56.3056 48.6587 56.038 48.6431 55.7884C48.6173 55.375 48.9315 55.019 49.3449 54.9931Z",
    fill: "#F94F44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.75 54.8333C37.2437 54.8333 36.8333 55.2437 36.8333 55.75C36.8333 56.2563 37.2437 56.6667 37.75 56.6667C38.2563 56.6667 38.6667 56.2563 38.6667 55.75C38.6667 55.2437 38.2563 54.8333 37.75 54.8333ZM35.3333 55.75C35.3333 54.4153 36.4153 53.3333 37.75 53.3333C39.0847 53.3333 40.1667 54.4153 40.1667 55.75C40.1667 57.0847 39.0847 58.1667 37.75 58.1667C36.4153 58.1667 35.3333 57.0847 35.3333 55.75Z",
    fill: "#F94F44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.947 50.2197C50.2399 50.5126 50.2399 50.9874 49.947 51.2803L33.2803 67.947C32.9874 68.2399 32.5126 68.2399 32.2197 67.947C31.9268 67.6541 31.9268 67.1792 32.2197 66.8863L48.8863 50.2197C49.1792 49.9268 49.6541 49.9268 49.947 50.2197Z",
    fill: "#F94F44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2387 59.122V59.122L42.0475 63.3215C41.5046 63.8644 40.6209 63.8649 40.078 63.322C39.7851 63.0291 39.7851 62.5542 40.078 62.2613C40.345 61.9943 40.7632 61.9707 41.057 62.1906L45.1775 58.0619C46.1204 57.119 47.6458 57.1185 48.5887 58.0613L48.5903 58.063L49.9486 59.4296C50.2406 59.7234 50.2392 60.1983 49.9454 60.4903C49.6516 60.7823 49.1767 60.7808 48.8847 60.487L47.528 59.122V59.122C47.1709 58.7656 46.5956 58.7653 46.2387 59.122Z",
    fill: "#F94F44"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 82,
    height: 116,
    rx: 8,
    stroke: "#F94F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErroImage);
export default __webpack_public_path__ + "static/media/erroImage.d221f260d994311561dab323f3c8b867.svg";
export { ForwardRef as ReactComponent };